import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Icon } from '@/components/general';
import { RemoveSpaces } from '@/utils/functions';
import { IProduct } from '@/components/Products/ProductsInfo';
import * as styled from './ProductsItem.styled';

interface IProductsItem {
  item: IProduct;
  onClick?: any;
}

export const ProductsItem: React.FC<IProductsItem> = ({ item, onClick }) => {
  const theme = useContext(ThemeContext);

  const stroke =
    item.title === 'Visual App Builder' ||
    item.title === 'Content Management System';

  return (
    <styled.ItemBox
      to={item.to ? item.to : `/${RemoveSpaces(item.title)}`}
      onClick={onClick}
    >
      <styled.IconBox
        $stroke={stroke}
        $visualAppBuilder={item.title === 'Visual App Builder'}
      >
        <Icon name={item.icon} color={theme.colors.secondaryBlack} />
      </styled.IconBox>
      <styled.TitleBox>
        <styled.Title>{item.title}</styled.Title>
        <styled.Description>{item.description}</styled.Description>
      </styled.TitleBox>
    </styled.ItemBox>
  );
};
